import { render } from "./form-tags.vue?vue&type=template&id=693b9150"
import script from "./form-tags.vue?vue&type=script&lang=js"
export * from "./form-tags.vue?vue&type=script&lang=js"

import exportComponent from "/home/devbuildsseatshopcom/dev.builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__